import { usePageContext } from '../providers/PageContextProvider';

/**
 * 현재 페이지 정보 획득 hook
 * @returns
 */
export const useCurrentPage = () => {
    const { currentPage, previousPage } = usePageContext();

    return {
        currentPageId: currentPage?.id ?? '',
        currentPage,
        previousPageId: previousPage?.id,
        previousPage,
    };
};
